// extracted by mini-css-extract-plugin
var _1 = "P6iQWwa1";
var _2 = "pQHfRmxv";
var _3 = "pQHfRmxv";
var _4 = "QOUEhayD";
var _5 = "QOUEhayD";
var _6 = "EOcR7Z6M";
var _7 = "JW6HnKG9";
var _8 = "xnLqDZHH";
var _9 = "JW6HnKG9";
var _a = "xnLqDZHH";
var _b = "VJF5RJxZ";
var _c = "ifZDZeYw";
var _d = "ifZDZeYw";
var _e = "Aqn99stR";
var _f = "O_G25qlu";
var _10 = "O_G25qlu";
var _11 = "oRcw7jP8";
export { _1 as "autocomplete", _2 as "barcode-button", _3 as "barcodeButton", _4 as "icon-barcode", _5 as "iconBarcode", _6 as "product", _7 as "product-category", _8 as "product-name", _9 as "productCategory", _a as "productName", _b as "search", _c as "search-button", _d as "searchButton", _e as "suggestion", _f as "suggestion-type", _10 as "suggestionType", _11 as "text" }
